import {
  doGETRequest,
  doPOSTRequest,
  doPUTRequest
} from "./Api";

class MilkDeliveryApi {
  // --- Vehicles ---
  public static async listVehicles() {
    const relativePath = "/production/milk-delivery/vehicles";
    return await doGETRequest(relativePath);
  }

  public static async getVehicleById(id: number) {
    const relativePath = `/production/milk-delivery/vehicles/${id}`;
    return await doGETRequest(relativePath);
  }

  public static async createOrUpdateVehicle(data: any) {
    const relativePath = "/production/milk-delivery/vehicles";
    const method = data.id ? doPUTRequest : doPOSTRequest;
    return await method(relativePath, data);
  }

  // --- Drivers ---
  public static async listDrivers() {
    const relativePath = "/production/milk-delivery/drivers";
    return await doGETRequest(relativePath);
  }

  public static async getDriverById(id: number) {
    const relativePath = `/production/milk-delivery/drivers/${id}`;
    return await doGETRequest(relativePath);
  }

  public static async createOrUpdateDriver(data: any) {
    const relativePath = "/production/milk-delivery/drivers";
    const method = data.id ? doPUTRequest : doPOSTRequest;
    return await method(relativePath, data);
  }

  // --- Deliveries ---
  public static async listDeliveries() {
    const relativePath = "/production/milk-delivery/deliveries";
    return await doGETRequest(relativePath);
  }

  public static async getDeliveryById(id: number) {
    const relativePath = `/production/milk-delivery/deliveries/${id}`;
    return await doGETRequest(relativePath);
  }

  public static async createOrUpdateDelivery(data: any) {
    const relativePath = "/production/milk-delivery/deliveries";
    const method = data.id ? doPUTRequest : doPOSTRequest;
    return await method(relativePath, data);
  }
}

export default MilkDeliveryApi;
